
<mat-card
    class="card-link"
    [ngClass]="{'flex-row': viewMode === 'lista'}"
    (click)="isLoading = true; dirigirirAlModulo.emit(modulo)"
>
    <!-- Icono -->
    <div class="card-icon"
        [ngClass]="{'no-margin-botton': viewMode === 'lista',
                'parpadeo': isLoading}"
    >
        <mat-icon>
            {{ modulo.icono || 'apartment' }}
        </mat-icon>
    </div>

    <div [ngClass]="{'margin-left': viewMode === 'lista'}">
        <!-- Título -->
        <h3 class="card-title"
            [ngClass]="{'text-left': viewMode === 'lista'}">
            {{modulo.modulo}}
        </h3>

        <!-- Descripción -->
        <p class="card-description" [ngClass]="{'text-left': viewMode === 'lista'}">
            {{modulo.descripcion || modulo.modulo}}
        </p>
    </div>

    <!-- Botón de acción -->
    <div class="card-action" [ngClass]="{'right-20': viewMode === 'lista',
                                'opacity': isLoading}">

        <ng-template [ngIf]="!isLoading">
            <mat-icon class="arrow-icon">arrow_forward</mat-icon>
        </ng-template>

        <ng-template [ngIf]="isLoading">
            <div class="spinner-container">                                                                                                                                               
                <mat-spinner [diameter]="20"></mat-spinner>
            </div> 
        </ng-template>
    </div>

    <!-- Indicador de borde activo -->
    <div
        [ngClass]="{'card-indicator': viewMode === 'grilla',
            'card-indicator-lista': viewMode === 'lista'}"
    ></div>
</mat-card>

